export default __webpack_public_path__ + "ec745dc44819714b7c2da33db81620fe.png";